<i18n src="./../../i18n/info_item_page.json"></i18n>

<template>
    <div v-if="loaded">
        <div v-if="exist" class="container-fluid">
            <vue-headful
                    :title="content.title + ' | mToilet'"
                    :description="content.pageDescription"
                    :url="pageUrl"/>
            <navigation-bar />

            <div id="paralax-subpage-section" class="lazy jumbotron mt-page-nav-image" data-bg="/assets/mt-news-page-1.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular par-text-1" style="opacity: 0.5;" v-text="$t('header')"/>
                </div>
            </div>

            <div class="container-fluid mt-subpage-section m-0 p-0">
                <div class="container-fluid m-0 p-0">
                    <div class="lazy container-fluid">
                        <div class="container">
                            <div class="content-container p-3 pt-5">
                                <div class="row pb-0 mb-0">
                                    <div class="col">
                                        <h1 class="pb-0 mb-0" v-text="content.title"/>
                                    </div>
                                </div>
                                <font-awesome-icon class="mt-c-grey-light mr-2" icon="user"/>
                                <small class="mr-4" v-text="content.author"/>
                                <font-awesome-icon class="mt-c-grey-light mr-2" icon="calendar-day"/>
                                <small v-text="content.date"/>
                                <div class="row pt-4">
                                    <div class="col">
                                        <img class="lazy float-left mt-news-image mr-4 mb-4 pt-1" :data-src="content.image" :alt="content.imageAlt">
                                        <div class="pull-left" v-html="content.summary"/>
                                    </div>
                                </div>
                            </div>

                            <main-footer/>

                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div v-else id="404-page">
            <page-not-found/>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import {Const} from "@/main";
    import NavigationBar from "@/components/commons/NavigationBar";
    import MainFooter from "@/components/commons/MainFooter";
    import PageNotFound from "@/components/commons/PageNotFound";
    import LazyLoad from "vanilla-lazyload";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "InfoItemPage",
        components: {PageNotFound, MainFooter, NavigationBar},
        data () {
            return {
                locale: this.$i18n.locale,
                content: {},
                exist: false,
                loaded: false,
                pageDescription: Const.MAIN_DESCRIPTION,
                pageUrl: Const.HOST + this.$route.path
            }
        },
        mounted () {
            axios.get(`${Const.API_HOST}/${this.locale}/content/info/page`, {
                params: {
                    "url": '/' + this.$route.params.pageName
                }
            })
            .then(function (response) {
                return {
                    status: response.status,
                    body: response.data
                };
            }).catch(function (error) {
            // eslint-disable-next-line no-console
            console.log(error);
            }).then(resp => {
                this.exist = (resp.status === 200)
                this.content = resp.body
                this.loaded = true

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });
        }
    }
</script>

<style scoped>
    #paralax-subpage-section {
        height: 200px;
    }

    @media (min-width: 768px) {
      .mt-news-image {
        width: 33%;
      }
    }

    @media (max-width: 768px) {
      .mt-news-image {
        width: 100%;
      }
    }
</style>